import { downloadPdfInvoiceData } from '../libs/apis/InvoiceApi';

export const DOWNLOAD_PDF_INVOICE_REQUEST = 'DOWNLOAD_PDF_INVOICE_REQUEST';
export const DOWNLOAD_PDF_INVOICE_SUCCESS = 'DOWNLOAD_PDF_INVOICE_SUCCESS';
export const DOWNLOAD_PDF_INVOICE_FAILURE = 'DOWNLOAD_PDF_INVOICE_FAILURE';

export const downloadPdfInvoice = params => dispatch => {
  dispatch({ type: DOWNLOAD_PDF_INVOICE_REQUEST });
  return downloadPdfInvoiceData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_PDF_INVOICE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_PDF_INVOICE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
